export const profile = {
  profileFavoritesIconTitle: 'Favorieten',
  profileEditIconTitle: 'Bewerken',
  profileShareIconTitle: 'Delen',
  profileAdditionalSectionTitle: 'Aanvullende info',
  profileFavoritesCurtainTitle: 'Favorieten',
  profileFavoriteActionTitle: 'Favoriet maken',
  profileFavoritedActionTitle: 'Toegevoegd aan favorieten',
  profileMessageAction: 'Bericht',
  profileCurtainAdd: 'Toevoegen',
  profileReportUser: 'Meld gebruiker',
  profileReportTitle: 'Meld',
  profileReportSuccess: 'Inhoud gemeld',
  profileReset: 'Resetten',
  profileApply: 'Toepassen',
  profileCustomInvalidEmail: 'is geen geldig e-mailadres',
  profileMaxContentSizeError: 'Je hebt de maximale inhoudsgrootte overschreden!',
  profileMaxAvatarSizeError: 'Je avatar is te groot!',
  profileFavoritesCurtainSearchInputText: 'Zoeken',
  profileTapShareCurtainOptionTitle: 'Kopieer link',
  profileTapShareLinkCopiedAlertTitle: 'Link gekopieerd!',
  profileQrShareCurtainTitle: 'Deel profiel',
  profileQrShareCurtainShareButtonTitle: 'Deel',
  profileQrShareCurtainCopyButtonTitle: 'Kopieer link',
  profileQrShareCurtainCopiedAlertTitle: 'Link gekopieerd!',
  profileQrTapShareProfileCurtainTitle: 'Deel je profiel',
  profileEditTitle: 'Bewerken',
  profileEditPersonalSectionTitle: 'Persoonlijke gegevens',
  profileEditContactsSectionTitle: 'Contacten',
  profileEditSocialSectionTitle: 'Sociale netwerken',
  profileEditAddSocialButtonTitle: 'Voeg sociaal netwerk toe',
  profileEditAdditionalSectionTitle: 'Aanvullende info',
  profileEditSaveButtonTitle: 'Opslaan',
  profileEditSavedAlertTitle: 'Profiel opgeslagen!',
  profileEditEmptyRequiredInputTitle: 'Waarde mag niet leeg zijn',
  profileEditEmptyRequiredEmailInputTitle: 'Publieke e-mail is geen geldig e-mailadres',
  profileEditEmptyRequiredErrorTitle: 'Er is iets mis gegaan!',
  profileEditSocialsHint: 'Voer de URL van je sociale profiel in',
  preferences: 'Voorkeuren',
  interestedIn: 'Geïnteresseerd in',
  expertIn: 'Ik ben een expert in',
  myPitch: 'Mijn pitch',
  qrBadge: 'QR Badge',
  touchpoints: 'Touchpoints',
  lookingFor: 'Ik ben op zoek naar',
  topicsToDiscuss: 'Onderwerpen om te bespreken',
  createNew: 'Maak nieuw',
  viewTopic: 'Bekijk onderwerp',
  hobbyInterests: "Hobby's & interesses",
  myNetwork: 'Mijn netwerk',
  seeAll: 'Zie alles',
  checkThemOut: 'Bekijk ze!',
  activities: 'Activiteiten',
  oneOnOne: '1:1 Vergadering',
  Leaderboard: 'Leaderbord',
  learnNetworking: 'Leer meer over Networking Hub',
  networkingGroup: 'Netwerk groep',
  networkingLevel: 'Netwerk niveau',
  addNote: 'Voeg notitie toe',
  notes: 'Notities',
  enterNote: 'Voer een notitie in',
  shareUserProfile: 'Deel gebruikersprofiel',
  flagUser: 'Meld gebruiker'
}
